// import required libraries
import $ from 'jquery';


// import components that run on every page
import navMenuToggle from './components/navMenuToggle';
import animateWhenInViewport from './actions/animateWhenInViewport';

// Import Pages
import accessibility from './actions/accessibility';
import PageNews from './pages/PageNews';
// call functions
accessibility();
navMenuToggle($);
PageNews($);
animateWhenInViewport($);
